module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Kategoria</label>\n    </dt>\n    <dd>\n        <input\n            ng-class=\"IssueFormCategoryStringCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"locations\"\n            ng-model=\"IssueFormCategoryStringCtrl.locations\"\n        />\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/category_string/issue_form_category.html
// module id = 653
// module chunks = 0